<script>
    import { Overlay, layout_cnv } from '../../'

    export default {
        name: 'PointAndFigure',
        mixins: [Overlay],
        methods: {
            meta_info() {
                return {
                    author: 'TradingCandle',
                    version: '1.0.0',
                    desc: 'Point and Figure Chart',
                    preset: {
                        name: 'PointAndFigure',
                        side: 'onchart',
                        settings: {
                            boxSize: 'auto',
                            reversalBoxes: 3,
                            colorCandleUp: '#23a776',
                            colorCandleDw: '#e54150',
                            lineWidth: 1
                        }
                    }
                }
            },
            init() {},
            draw(ctx) {
                let layout = this.$props.layout

                if (this.$props.sub === this.$props.data) {
                    var candles = layout.candles
                } else {
                    candles = layout_cnv(this).candles
                }

                if (!candles || candles.length < 2) return

                let boxSize = this.getBoxSize(candles)
                let reversalBoxes = this.sett.reversalBoxes || 3
                if (boxSize <= 0) return

                // Build P&F columns
                let columns = this.buildColumns(candles, boxSize, reversalBoxes)

                // Render columns
                this.renderColumns(ctx, layout, columns, candles, boxSize)
            },
            buildColumns(candles, boxSize, reversalBoxes) {
                let columns = []
                let direction = 0 // 1 = X (up), -1 = O (down)
                let currentCol = { direction: 0, boxes: [], startPrice: 0 }
                let highMark = candles[0].raw[2]
                let lowMark = candles[0].raw[3]

                for (var i = 0, n = candles.length; i < n; i++) {
                    let high = candles[i].raw[2]
                    let low = candles[i].raw[3]

                    if (direction === 0) {
                        // Determine initial direction
                        if (high - lowMark >= boxSize * reversalBoxes) {
                            direction = 1
                            currentCol = { direction: 1, startPrice: lowMark, endPrice: high, candleIdx: i }
                            highMark = high
                        } else if (highMark - low >= boxSize * reversalBoxes) {
                            direction = -1
                            currentCol = { direction: -1, startPrice: highMark, endPrice: low, candleIdx: i }
                            lowMark = low
                        }
                        continue
                    }

                    if (direction === 1) {
                        if (high > highMark) {
                            highMark = high
                            currentCol.endPrice = high
                        }
                        if (highMark - low >= boxSize * reversalBoxes) {
                            // Reversal to O column
                            columns.push({ ...currentCol })
                            direction = -1
                            lowMark = low
                            currentCol = { direction: -1, startPrice: highMark - boxSize, endPrice: low, candleIdx: i }
                        }
                    } else {
                        if (low < lowMark) {
                            lowMark = low
                            currentCol.endPrice = low
                        }
                        if (high - lowMark >= boxSize * reversalBoxes) {
                            // Reversal to X column
                            columns.push({ ...currentCol })
                            direction = 1
                            highMark = high
                            currentCol = { direction: 1, startPrice: lowMark + boxSize, endPrice: high, candleIdx: i }
                        }
                    }
                }

                // Push final column
                if (currentCol.direction !== 0) {
                    columns.push(currentCol)
                }

                return columns
            },
            renderColumns(ctx, layout, columns, candles, boxSize) {
                if (columns.length === 0) return

                let step = candles.length > 1 ?
                    (candles[candles.length - 1].x - candles[0].x) / Math.max(columns.length - 1, 1) : 50
                let colWidth = Math.max(step * 0.7, 8)

                for (var i = 0; i < columns.length; i++) {
                    let col = columns[i]
                    let x = candles[0].x + i * step

                    let startY = Math.floor(col.startPrice * layout.A + layout.B)
                    let endY = Math.floor(col.endPrice * layout.A + layout.B)
                    let top = Math.min(startY, endY)
                    let bottom = Math.max(startY, endY)

                    // Draw boxes
                    let numBoxes = Math.max(Math.floor((bottom - top) / (boxSize * Math.abs(layout.A))), 1)
                    let boxH = (bottom - top) / numBoxes

                    for (var j = 0; j < numBoxes; j++) {
                        let boxTop = top + j * boxH
                        let boxBot = boxTop + boxH
                        let cx = Math.floor(x)
                        let hw = colWidth * 0.4

                        if (col.direction === 1) {
                            // X marks (bullish)
                            ctx.strokeStyle = this.upColor
                            ctx.lineWidth = 1.5
                            ctx.beginPath()
                            ctx.moveTo(cx - hw, boxTop)
                            ctx.lineTo(cx + hw, boxBot)
                            ctx.moveTo(cx + hw, boxTop)
                            ctx.lineTo(cx - hw, boxBot)
                            ctx.stroke()
                        } else {
                            // O marks (bearish)
                            ctx.strokeStyle = this.downColor
                            ctx.lineWidth = 1.5
                            ctx.beginPath()
                            ctx.arc(cx, (boxTop + boxBot) / 2, hw * 0.8, 0, Math.PI * 2)
                            ctx.stroke()
                        }
                    }
                }
            },
            getBoxSize(candles) {
                if (this.sett.boxSize && this.sett.boxSize !== 'auto') {
                    return parseFloat(this.sett.boxSize)
                }
                // Auto: use ATR / 2
                let sum = 0
                for (var i = 0, n = candles.length; i < n; i++) {
                    sum += candles[i].raw[2] - candles[i].raw[3]
                }
                return (sum / candles.length) * 0.5
            },
            use_for() { return ['PointAndFigure'] },
            y_range() {
                var hi = -Infinity, lo = Infinity
                for (var i = 0, n = this.sub.length; i < n; i++) {
                    let x = this.sub[i]
                    if (x[2] > hi) hi = x[2]
                    if (x[3] < lo) lo = x[3]
                }
                return [hi, lo]
            }
        },
        computed: {
            sett() { return this.$props.settings },
            upColor() { return this.sett.colorCandleUp || this.$props.colors.candleUp || '#23a776' },
            downColor() { return this.sett.colorCandleDw || this.$props.colors.candleDw || '#e54150' },
            lineWidth() { return this.sett.lineWidth || 1 }
        }
    }
</script>
